import { useCallback, useEffect, useState } from 'react'
import { Selector, useDispatch, useSelector } from 'react-redux'

import { ServiceValues } from '../helpers/ReduxHelpers'

export const useServiceRequest = <Data, Params>(
  selector: Selector<any, ServiceValues<Data, Params>>,
  action: any,
  actionReset?: any,
  onComplete?: (s: ServiceValues<Data, Params>) => void | null
) => {
  const [isPending, setIsPending] = useState(false)
  const dispatch = useDispatch()
  const response: ServiceValues<Data, Params> = useSelector(selector)

  const request = useCallback(
    (values?: Params) => {
      setIsPending(true)
      dispatch?.(action(values))
    },
    [dispatch, action]
  )

  useEffect(() => {
    if (response.success && isPending) {
      onComplete?.(response)
    }
    if ((response.pending || response.complete) && !isPending && actionReset) {
      dispatch?.(actionReset())
    }
  }, [dispatch, isPending, onComplete, actionReset, response])

  return { response, request }
}
